import { apiClient } from "@/api/client";
import { API_ENDPOINTS } from "@/api/endpoints";
import type { MatchEvent, CreateEventRequest } from "@/types/api.types";

export const eventsService = {
  logEvent: async (data: CreateEventRequest): Promise<MatchEvent> => {
    return apiClient.post(API_ENDPOINTS.EVENTS.CREATE, data);
  },

  getMatchEvents: async (matchId: number): Promise<MatchEvent[]> => {
    return apiClient.get(API_ENDPOINTS.EVENTS.MATCH_EVENTS(matchId));
  },

  deleteEvent: async (id: number): Promise<{ message: string }> => {
    return apiClient.delete(API_ENDPOINTS.EVENTS.DELETE(id));
  },

  getRecentEvents: async (limit = 20): Promise<MatchEvent[]> => {
    return apiClient.get(`${API_ENDPOINTS.EVENTS.RECENT}?limit=${limit}`);
  },

  logBulkAppearances: async (data: {
    matchId: number;
    appearances: { playerId: number; minutesPlayed: number }[];
  }): Promise<{ message: string; results: MatchEvent[] }> => {
    return apiClient.post(API_ENDPOINTS.EVENTS.BULK_APPEARANCES, data);
  },
};
